module.exports = __webpack_public_path__ + "04_bob_gray.16585cec.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/04_bob_gray.png
// module id = +L8M
// module chunks = 0